import {
  PageInnerContent,
  PageGridContainer,
  PageChildPages,
  PagePageContent
} from './styles';
interface PageProps {
  children: any;
  maxWidth?: string;
}
export const Page = ({ children, maxWidth }: PageProps) => {
    return (
      <PageInnerContent>
        <PageGridContainer $maxW={maxWidth}>
          <PagePageContent>
            <PageChildPages>{children}</PageChildPages>
          </PagePageContent>
        </PageGridContainer>
      </PageInnerContent>
    );
  };